import { createContext } from "react";

const APIContext = createContext({
  patientID: null,
  patientQuery: null,
  dispositionsQuery: null,
  patientDispositionsQuery: null,
  eddQuery: null,
  milestonesQuery: null,
  patientMilestonesQuery: null,
  configurationQuery: null,
  userPreferencesQuery: null,
  authContextID: null,
  intelligenceTextQuery: null,
  medicallyReadyStatusQuery: null,
  patientInsightsQuery: null,
  activeRoundingSessionQuery: null,
  patientConsiderationsQuery: null,
  patientNotesQuery: null,
  analytics: null,
  showErrorToast: false,
  setShowErrorToast: null,
  sessionExpired: false,
  isViewOnly: false,
});

export default APIContext;
